import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getHasUnrecoverableError } from 'ContentEditorUI/redux/selectors/collaborationSidebarSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
function ApprovalAvailabilityTooltip({
  children
}) {
  const hasUnrecoverableError = useSelector(getHasUnrecoverableError);
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !hasUnrecoverableError,
    placement: "left",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "approvals.approvalsUnavailableTooltip"
    }),
    children: children
  });
}
export default ApprovalAvailabilityTooltip;